import React from 'react';
import { Typography } from 'fronton-react';
import { useTranslation } from 'react-i18next';
import { deliveryInfo, deliveryInfoText } from './delivery-info.styles';

export const DATA_QA_DELIVERY_INFO = 'delivery-info';

type Props = {
  maxStockAvailable: number;
  regionName?: string;
  uom?: string;
};

export const DeliveryInfo: React.FC<Props> = ({ maxStockAvailable, regionName, uom }) => {
  const { t } = useTranslation();
  return (
    <div className={deliveryInfo} data-qa={DATA_QA_DELIVERY_INFO}>
      <div className={deliveryInfoText}>
        <Typography variant="s" size="body_accent" color="success-dark">
          {t('product-info.delivery.available-to-order')} {maxStockAvailable} {uom}
        </Typography>
        {regionName && <Typography variant="caption">{regionName}</Typography>}
      </div>
    </div>
  );
};
